import { render, staticRenderFns } from "./PreviousBuilds.vue?vue&type=template&id=f427a1fa&scoped=true&"
import script from "./PreviousBuilds.vue?vue&type=script&lang=ts&"
export * from "./PreviousBuilds.vue?vue&type=script&lang=ts&"
import style0 from "./PreviousBuilds.vue?vue&type=style&index=0&id=f427a1fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f427a1fa",
  null
  
)

export default component.exports